/**
 * Português do Brasil (pt-BR) — registro de operador de cassino online brasileiro.
 *
 * COBERTURA: esta é uma tradução parcial e incremental. Los módulos que aún no están
 * traducidos caen automaticamente al español, porque `fallbackLng` en index.js es "es".
 * Añadir un idioma = crear el módulo en ./pt-BR/ e importarlo aquí.
 *
 * Traducidos: login, registro, navegación lateral, pie de página, contactos/favoritos,
 * monedas y metadatos SEO.
 * Pendientes (siguen en español): games, bankDeposit, quiniela, widthdrawalSteps,
 * gameFeed, userProfile, mobilePayment, lottery, TOS, identity, accountMovement,
 * transferSteps, accounts, notifications, y el resto.
 */

import {contact} from "./pt-BR/contact";
import {currency} from "./pt-BR/currency";
import {footer} from "./pt-BR/footer";
import {loginModal} from "./pt-BR/loginModal";
import {meta} from "./pt-BR/meta";
import {registrationForm} from "./pt-BR/registrationForm";
import {sideNavbar} from "./pt-BR/sideNavbar";

const ptBR = {
  ...meta,
  ...loginModal,
  ...registrationForm,
  ...sideNavbar,
  ...footer,
  ...contact,
  ...currency,
};

export default ptBR;
